import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import lo from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import DataTable from 'organisms/DataTable'
import { getAllCompaniesData } from 'Redux/actions/CompanyListActions'
import { toggleIsLoading } from 'Redux/actions/ViewStateActions'
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions'
import { TableWrapper } from './styles'
import _ from 'lodash'
import { selectionFormatter } from 'components/molecules/TableFormatters/selectionFormatter'
import ModalPage from 'templates/ModalPage/index'
import { actionFormatter } from 'components/molecules/TableFormatters/actionFormatter'
import { RitOBModal } from 'components/organisms/RitOBModal/index'
import { RIT_OB_VALIDATIONS } from 'fixtures/api'
import { postNewData, putData } from 'services/cmsService'
import { TxtFailedSubmitData, TxtSuccessSubmit } from 'fixtures/texts'
import FormCheck from 'components/atoms/Inputs/FormCheck'
import { permissionCheck } from 'helpers/permissionCheckHelper'
import {
  contractorReportOBDelete,
  contractorReportOBUpdate,
} from 'fixtures/permissions'
class RitOBValidation extends Component {
  constructor(props) {
    super(props)

    this.state = {
      data: _.cloneDeep(props.data),
      allowUpdate: permissionCheck(
        props.user.permissions,
        contractorReportOBUpdate
      ),
      allowDelete: permissionCheck(
        props.user.permissions,
        contractorReportOBDelete
      ),
      navList: ['RitOB Validation'],
      modalData: {},
      isShowModal: false,
      isSubmitDisabled: false,
      isError: { status: false, msg: '' },
    }
  }

  componentDidMount() {
    this.props.onRef(this)
    this.props.getAllCompaniesData()
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  componentDidUpdate(prevProps) {
    const { data } = this.props
    if (!lo.isEqual(prevProps.data, data)) {
      this.setState({ data })
    }
  }

  toggleChecklist = (row, field) => {
    const { data } = this.state
    const newData = data.map((d) =>
      d.id === row.id ? { ...d, [field]: !row[field] } : d
    )
    this.setState({ data: newData })
    this.props.onChecked(row.id)
  }

  toggleAllChecklist = () => {
    const { data } = this.state
    const { isCheckedAll } = this.props
    const newData = data.map((d) => ({ ...d, isChecked: !isCheckedAll }))
    this.setState({ data: newData })
    this.props.onAllChecked(!isCheckedAll ? newData.map((d) => d.id) : [])
  }

  switchModal(validationData) {
    const { isShowModal } = this.state
    this.setState({ modalData: validationData }, () => {
      this.setState({ isShowModal: !isShowModal })
    })
  }

  addNew = () => {
    const { isShowModal } = this.state

    const company = this.props.companiesList.find(
      (c) => c.id === this.props.companiesList[0].id
    )
    this.setState({
      isShowModal: !isShowModal,
      modalData: {
        companyId: this.props.companiesList[0].id || null,
        transtemplateName: '',
        source: '',
        destination: '',
        date: new Date(),
        shiftNum: 0,
        activity: '',
        contractorId: company.contractors[0].id || null,
        truck: '',
        trips: 0,
        distanceBeforeValidation: 0,
        distanceAfterValidation: 0,
        capacity: 0,
        total: 0,
        product: '',
        equipment: '',
        comment: '',
        status: '',
        excavator: '',
        area: '',
        block: '',
      },
    })
  }

  onDelete(row) {
    this.props.onDelete(row)
  }

  onChangeModalData = (val, field) => {
    const { modalData } = this.state
    modalData[field] = val
    if (field === 'companyId') {
      const company = this.props.companiesList.find((c) => c.id === val)
      modalData.contractorId = company ? company.contractors[0].id : null
    }
    this.setState({ modalData })
  }

  onSubmit = () => {
    const { modalData } = this.state
    const { companiesList } = this.props
    const {
      id,
      companyObject,
      contractorObject,
      createdAt,
      createdBy,
      excavatorObject,
      isChecked,
      mmFetchedAt,
      mmRemarks,
      mmStatus,
      pitObject,
      shiftObject,
      updatedAt,
      updatedBy,
      validatedAt,
      validatedBy,
      validatedByObject,
      ...data
    } = modalData

    const uri = id ? `${RIT_OB_VALIDATIONS}/${id}` : RIT_OB_VALIDATIONS

    const company = companiesList.find((d) => d.id === data.companyId)
    const contractors = company ? company.contractors : []
    const contractor = contractors.find((d) => d.id === data.contractorId)
    const form = {
      ...data,
      id: data.id || uuidv4(),
      date: moment(data.date).format(),
      mine: company ? company.code : '',
      contractor: contractor ? contractor.code : '',
    }

    this.setState({ isSubmitDisabled: true }, async () => {
      try {
        const res = id ? await putData(uri, form) : await postNewData(uri, form)
        if (res.status >= 200 && res.status < 300) {
          alert(TxtSuccessSubmit)
          this.props.onRefresh()
          this.setState({
            isShowModal: false,
            modalData: {},
          })
        }
      } catch (error) {
        alert(TxtFailedSubmitData)
      } finally {
        this.setState({ isSubmitDisabled: false })
      }
    })
  }

  onSizePerPageChange = (size) => {
    const { setLocalSettingsTableData, settingsTable } = this.props
    const settings = lo.cloneDeep(settingsTable)
    settings.sizePerPage[this.state.navList[0]] = size
    setLocalSettingsTableData(settings)
  }

  render() {
    const {
      settingsTable,
      viewState: { isMobileView },
      isCheckedAll,
    } = this.props
    const { data, isShowModal, modalData, isSubmitDisabled, isError, navList } =
      this.state

    const sizePerPage = settingsTable.sizePerPage[navList[0]]

    const isContractor =
      this.props.user.userRole === 'CONTRACTOR' ||
      String(this.props.user.department.name)
        .toLowerCase()
        .includes('contractor')

    const columnConfig = [
      {
        dataField: 'id',
        text: '',
        sort: false,
        headerFormatter: () => (
          <FormCheck
            value={isCheckedAll}
            allowEdit={data && data.length > 0}
            fn={() => this.toggleAllChecklist()}
          />
        ),
        formatter: (cell, row, rowIndex, formatExtraData) =>
          selectionFormatter(cell, row, rowIndex, formatExtraData),
        formatExtraData: {
          allowEdit: true,
          field: 'isChecked',
          fn: (row, field) => this.toggleChecklist(row, field),
        },
        headerAttrs: { width: isMobileView ? 200 : 500 },
        headerAlign: 'center',
        align: 'center',
        editable: false,
        isDummyField: true,
      },
      {
        dataField: 'action',
        text: 'Action',
        sort: false,
        headerStyle: { width: isMobileView ? 100 : 150 },
        formatter: actionFormatter,
        formatExtraData: {
          style: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          },
          allowEdit: this.state.allowUpdate,
          allowDel: this.state.allowDelete,
          isContractor: this.props.user.department.name === 'CONTRACTOR',
          edit: (row) => this.switchModal.bind(this, row),
          del: (row) => this.onDelete.bind(this, row),
        },
        isDummyField: true,
      },
      {
        dataField: 'companyObject.code',
        text: 'Mine',
        sort: true,
      },
      {
        dataField: 'transtemplateName',
        text: 'Trans Template Name',
        headerStyle: { minWidth: '250px' },
        sort: true,
      },
      {
        dataField: 'source',
        text: 'Source',
        headerStyle: { minWidth: '350px' },
        sort: true,
      },
      {
        dataField: 'destination',
        text: 'Destination',
        headerStyle: { minWidth: '450px' },
        sort: true,
      },
      {
        dataField: 'date',
        text: 'Date',
        headerStyle: { minWidth: '150px' },
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return (
            <div>
              {row.date ? moment(row.date).format('YYYY/MM/DD HH:mm') : '-'}
            </div>
          )
        },
        sort: true,
      },
      {
        dataField: 'shiftNum',
        text: 'Shift',
        sort: true,
      },
      {
        dataField: 'activity',
        text: 'Activity',
        sort: true,
      },
      {
        dataField: 'contractor',
        text: 'Contractor',
        sort: true,
      },
      {
        dataField: 'truck',
        headerStyle: { minWidth: '150px' },
        text: 'Truck',
        sort: true,
      },
      {
        dataField: 'trips',
        text: 'Trips',
        sort: true,
      },
      {
        dataField: 'distanceBeforeValidation',
        text: 'Distance Before Validation',
        sort: true,
      },
      {
        dataField: 'distanceAfterValidation',
        text: 'Distance After Validation',
        sort: true,
      },
      {
        dataField: 'capacity',
        text: 'Capacity',
        sort: true,
      },
      {
        dataField: 'total',
        text: 'Total',
        sort: true,
      },
      {
        dataField: 'product',
        headerStyle: { minWidth: '150px' },
        text: 'Product',
        sort: true,
      },
      {
        dataField: 'equipment',
        headerStyle: { minWidth: '150px' },
        text: 'Equipment',
        sort: true,
      },
      {
        dataField: 'comment',
        text: 'Comment',
        sort: true,
      },
      {
        dataField: 'status',
        text: 'Status',
        sort: true,
      },
      {
        dataField: 'excavator',
        text: 'Excavator',
        sort: true,
      },
      {
        dataField: 'area',
        text: 'Area',
        sort: true,
      },
      {
        dataField: 'block',
        text: 'Block',
        sort: true,
      },
      {
        dataField: 'validatedAt',
        text: 'Validated At',
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return (
            <div>
              {row.validatedAt
                ? moment(row.validatedAt).format('DD/MM/YYYY - h:mm A')
                : '-'}
            </div>
          )
        },
        headerStyle: { minWidth: '250px' },
        headerAlign: 'center',
        align: 'center',
        sort: true,
      },
      {
        dataField: 'validatedBy',
        text: 'Validated By',
        headerStyle: { minWidth: '250px' },
        headerAlign: 'center',
        align: 'center',
        sort: true,
      },
      {
        dataField: 'mmStatus',
        text: 'MM Status',
        headerStyle: { minWidth: '150px' },
        sort: true,
        headerAlign: 'center',
        align: 'center',
        formatter: (cell) => {
          return cell ? cell : '-'
        },
      },
      {
        dataField: 'mmRemarks',
        text: 'MM Remarks',
        headerStyle: { minWidth: '350px' },
        sort: true,
      },
    ]

    return (
      <>
        <TableWrapper>
          <DataTable
            isMobile={isMobileView}
            fnEdit={this.fnEdit}
            dataList={data}
            columnConfig={columnConfig}
            containerClassName="p-0"
            wrapperClasses="table-responsive"
            isInlineEdit
            sizePerPage={sizePerPage}
            onSizePerPageChange={this.onSizePerPageChange}
          />
        </TableWrapper>

        <ModalPage
          isOpen={isShowModal}
          fnSwitch={this.switchModal.bind(this)}
          contentChild={
            <RitOBModal
              fnChange={this.onChangeModalData.bind(this)}
              fnSubmit={this.onSubmit.bind(this)}
              fnSwitch={this.switchModal.bind(this)}
              ritOBData={modalData}
              isDisabled={isSubmitDisabled}
              isError={isError}
              isMobileView={isMobileView}
              {...this.props}
            />
          }
        />
      </>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState,
    companiesList: state.companiesList,
    settingsTable: state.settingsTable,
    user: state.userLogin ? state.userLogin.userDetail : {},
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      toggleIsLoading,
      getAllCompaniesData,
      setLocalSettingsTableData,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(RitOBValidation)
